import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IContentItems } from '@interfaces/settlement-fund/settlement-fund.model';
import { c11nLink } from '@shared/helpers';

import { FooterDisclaimerContent } from '../../services/content/content-jsons/footer-disclaimer-content';

type DisclaimerContentKey = keyof typeof FooterDisclaimerContent | 'vcd';

@Component({
  selector: 'app-footer-disclaimer',
  templateUrl: './footer-disclaimer.component.html',
  styleUrls: ['./footer-disclaimer.component.scss'],
  standalone: true,
  imports: [],
})
export class FooterDisclaimerComponent implements OnInit, OnChanges {
  @Input() disclaimer: DisclaimerContentKey | undefined;
  @Input() contentFromMFE?: IContentItems;

  content: string = '';

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  ngOnInit(): void {
    if (this.disclaimer && this.disclaimer !== 'vcd') {
      this.content = FooterDisclaimerContent[this.disclaimer];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['contentFromMFE'] && this.contentFromMFE && this.disclaimer === 'vcd') {
      this.content = Object.values(this.contentFromMFE)
        .map((value) => this.cleanMFEContent(value))
        .join('<br><br>');
    }
  }

  cleanMFEContent = (text: string): string => {
    const regex = /\[\{([^}]+)\}\s*\{([^}]+)\}\s*\{([^}]+)\}\]/g;

    const replacement = (match: string, linkText: string, url: string): string => {
      return c11nLink(url, linkText, true, [`c11n-link`, `c11n-link--primary`]);
    };

    return text.replace(regex, replacement).replace(/\|$/, '').replace(/\|/g, '<br><br>');
  };
}
